import React, { useState } from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import makeAnimated from 'react-select/animated';
import TeacherForm from './TeacherForm'
import Grid from "../../../Grid";

const TeacherAccordion = ({ initialGroups, teachers }) => {
  const [studentGroups, setStudentGroups] = useState(initialGroups);

  const renderAccordionBody = (teacher, students, studentRecord) => (
    <AccordionDetails>
      <Grid container item justify='flex-end'>
        <Grid item xs={6}>
          <TeacherForm
            teacher={teacher}
            studentGroups={studentGroups}
            teachers={teachers}
            setStudentGroups={setStudentGroups}
          />
        </Grid>

        <Grid item xs={6}>
          <ul>
            {studentRecord && (
              <li>
                The student record associated to this teacher is {' '}

                <strong>
                  {studentRecord.first_name} {studentRecord.last_name}
                </strong>
              </li>
            )}

            <hr />
            <p>All students in this class:</p>

            {students.map((student) => (
              <li key={student.id}>{student.first_name} {student.last_name}</li>
            ))}
          </ul>
        </Grid>
      </Grid>
    </AccordionDetails>
  )

  const renderAccordionContent = () => (
    Object.values(studentGroups).map((groups) => {
      const teacher = groups[0];
      const students = groups[1];
      const recordIsEnrolled = groups[2];
      const studentRecord = groups[3];

      return (
        <Accordion key={teacher.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id={teacher.id}
          >
            <p>{teacher.name} {teacher.student_id && <CheckCircleIcon />}</p>
          </AccordionSummary>
          {renderAccordionBody(teacher, students, studentRecord)}
        </Accordion>
      )
    })
  )

  return (
    <div>
      {renderAccordionContent()}
    </div>
  );
}

export default TeacherAccordion;
